// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IVehicleColorType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class VehicleColorType implements IVehicleColorType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Amethyst (purple) VehicleColorType
	**/
    get AME(): IVehicleColorType {
        return this.FromId(1);
    }
    /**
		Returns Beige VehicleColorType
	**/
    get BGE(): IVehicleColorType {
        return this.FromId(2);
    }
    /**
		Returns Black VehicleColorType
	**/
    get BLK(): IVehicleColorType {
        return this.FromId(3);
    }
    /**
		Returns Blue VehicleColorType
	**/
    get BLU(): IVehicleColorType {
        return this.FromId(4);
    }
    /**
		Returns Blue, Dark VehicleColorType
	**/
    get DBL(): IVehicleColorType {
        return this.FromId(5);
    }
    /**
		Returns Blue, Light VehicleColorType
	**/
    get LBL(): IVehicleColorType {
        return this.FromId(6);
    }
    /**
		Returns Bronze VehicleColorType
	**/
    get BRZ(): IVehicleColorType {
        return this.FromId(7);
    }
    /**
		Returns Brown VehicleColorType
	**/
    get BRO(): IVehicleColorType {
        return this.FromId(8);
    }
    /**
		Returns Camouflage VehicleColorType
	**/
    get CAM(): IVehicleColorType {
        return this.FromId(9);
    }
    /**
		Returns Chrome/Stainless Steel VehicleColorType
	**/
    get COM(): IVehicleColorType {
        return this.FromId(10);
    }
    /**
		Returns Copper VehicleColorType
	**/
    get CPR(): IVehicleColorType {
        return this.FromId(11);
    }
    /**
		Returns Cream/Ivory VehicleColorType
	**/
    get CRM(): IVehicleColorType {
        return this.FromId(12);
    }
    /**
		Returns Gold VehicleColorType
	**/
    get GLD(): IVehicleColorType {
        return this.FromId(13);
    }
    /**
		Returns Gray VehicleColorType
	**/
    get GRY(): IVehicleColorType {
        return this.FromId(14);
    }
    /**
		Returns Green VehicleColorType
	**/
    get GRN(): IVehicleColorType {
        return this.FromId(15);
    }
    /**
		Returns Green, Dark VehicleColorType
	**/
    get DGR(): IVehicleColorType {
        return this.FromId(16);
    }
    /**
		Returns Green, Light VehicleColorType
	**/
    get LGR(): IVehicleColorType {
        return this.FromId(17);
    }
    /**
		Returns Lavender (purple) VehicleColorType
	**/
    get LAV(): IVehicleColorType {
        return this.FromId(18);
    }
    /**
		Returns Maroon/Burgundy VehicleColorType
	**/
    get MAR(): IVehicleColorType {
        return this.FromId(19);
    }
    /**
		Returns Mauve (purple) VehicleColorType
	**/
    get MVE(): IVehicleColorType {
        return this.FromId(20);
    }
    /**
		Returns Multicolored VehicleColorType
	**/
    get MULCOL(): IVehicleColorType {
        return this.FromId(21);
    }
    /**
		Returns Orange VehicleColorType
	**/
    get ONG(): IVehicleColorType {
        return this.FromId(22);
    }
    /**
		Returns Pink VehicleColorType
	**/
    get PNK(): IVehicleColorType {
        return this.FromId(23);
    }
    /**
		Returns Purple VehicleColorType
	**/
    get PLE(): IVehicleColorType {
        return this.FromId(24);
    }
    /**
		Returns Red VehicleColorType
	**/
    get RED(): IVehicleColorType {
        return this.FromId(25);
    }
    /**
		Returns Silver/Aluminum VehicleColorType
	**/
    get SIL(): IVehicleColorType {
        return this.FromId(26);
    }
    /**
		Returns Tan VehicleColorType
	**/
    get TAN(): IVehicleColorType {
        return this.FromId(27);
    }
    /**
		Returns Taupe (brown) VehicleColorType
	**/
    get TPE(): IVehicleColorType {
        return this.FromId(28);
    }
    /**
		Returns Teal VehicleColorType
	**/
    get TEA(): IVehicleColorType {
        return this.FromId(29);
    }
    /**
		Returns Turquoise VehicleColorType
	**/
    get TRQ(): IVehicleColorType {
        return this.FromId(30);
    }
    /**
		Returns White VehicleColorType
	**/
    get WHI(): IVehicleColorType {
        return this.FromId(31);
    }
    /**
		Returns Yellow VehicleColorType
	**/
    get YEL(): IVehicleColorType {
        return this.FromId(32);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'AME', displayValue: 'Amethyst (purple)', description: 'Amethyst (purple)', sortOrder: 5, active: true });
        this._dictionary.add('2', { id: 2, value: 'BGE', displayValue: 'Beige', description: 'Beige', sortOrder: 10, active: true });
        this._dictionary.add('3', { id: 3, value: 'BLK', displayValue: 'Black', description: 'Black', sortOrder: 15, active: true });
        this._dictionary.add('4', { id: 4, value: 'BLU', displayValue: 'Blue', description: 'Blue', sortOrder: 20, active: true });
        this._dictionary.add('5', { id: 5, value: 'DBL', displayValue: 'Blue, Dark', description: 'Blue, Dark', sortOrder: 25, active: true });
        this._dictionary.add('6', { id: 6, value: 'LBL', displayValue: 'Blue, Light', description: 'Blue, Light', sortOrder: 30, active: true });
        this._dictionary.add('7', { id: 7, value: 'BRZ', displayValue: 'Bronze', description: 'Bronze', sortOrder: 35, active: true });
        this._dictionary.add('8', { id: 8, value: 'BRO', displayValue: 'Brown', description: 'Brown', sortOrder: 40, active: true });
        this._dictionary.add('9', { id: 9, value: 'CAM', displayValue: 'Camouflage', description: 'Camouflage', sortOrder: 45, active: true });
        this._dictionary.add('10', { id: 10, value: 'COM', displayValue: 'Chrome/Stainless Steel', description: 'Chrome/Stainless Steel', sortOrder: 50, active: true });
        this._dictionary.add('11', { id: 11, value: 'CPR', displayValue: 'Copper', description: 'Copper', sortOrder: 55, active: true });
        this._dictionary.add('12', { id: 12, value: 'CRM', displayValue: 'Cream/Ivory', description: 'Cream/Ivory', sortOrder: 60, active: true });
        this._dictionary.add('13', { id: 13, value: 'GLD', displayValue: 'Gold', description: 'Gold', sortOrder: 65, active: true });
        this._dictionary.add('14', { id: 14, value: 'GRY', displayValue: 'Gray', description: 'Gray', sortOrder: 70, active: true });
        this._dictionary.add('15', { id: 15, value: 'GRN', displayValue: 'Green', description: 'Green', sortOrder: 75, active: true });
        this._dictionary.add('16', { id: 16, value: 'DGR', displayValue: 'Green, Dark', description: 'Green, Dark', sortOrder: 80, active: true });
        this._dictionary.add('17', { id: 17, value: 'LGR', displayValue: 'Green, Light', description: 'Green, Light', sortOrder: 85, active: true });
        this._dictionary.add('18', { id: 18, value: 'LAV', displayValue: 'Lavender (purple)', description: 'Lavender (purple)', sortOrder: 90, active: true });
        this._dictionary.add('19', { id: 19, value: 'MAR', displayValue: 'Maroon/Burgundy', description: 'Maroon/Burgundy', sortOrder: 95, active: true });
        this._dictionary.add('20', { id: 20, value: 'MVE', displayValue: 'Mauve (purple)', description: 'Mauve (purple)', sortOrder: 100, active: true });
        this._dictionary.add('21', { id: 21, value: 'MUL/COL', displayValue: 'Multicolored', description: 'Multicolored', sortOrder: 105, active: true });
        this._dictionary.add('22', { id: 22, value: 'ONG', displayValue: 'Orange', description: 'Orange', sortOrder: 110, active: true });
        this._dictionary.add('23', { id: 23, value: 'PNK', displayValue: 'Pink', description: 'Pink', sortOrder: 115, active: true });
        this._dictionary.add('24', { id: 24, value: 'PLE', displayValue: 'Purple', description: 'Purple', sortOrder: 120, active: true });
        this._dictionary.add('25', { id: 25, value: 'RED', displayValue: 'Red', description: 'Red', sortOrder: 125, active: true });
        this._dictionary.add('26', { id: 26, value: 'SIL', displayValue: 'Silver/Aluminum', description: 'Silver/Aluminum', sortOrder: 130, active: true });
        this._dictionary.add('27', { id: 27, value: 'TAN', displayValue: 'Tan', description: 'Tan', sortOrder: 135, active: true });
        this._dictionary.add('28', { id: 28, value: 'TPE', displayValue: 'Taupe (brown)', description: 'Taupe (brown)', sortOrder: 140, active: true });
        this._dictionary.add('29', { id: 29, value: 'TEA', displayValue: 'Teal', description: 'Teal', sortOrder: 145, active: true });
        this._dictionary.add('30', { id: 30, value: 'TRQ', displayValue: 'Turquoise', description: 'Turquoise', sortOrder: 150, active: true });
        this._dictionary.add('31', { id: 31, value: 'WHI', displayValue: 'White', description: 'White', sortOrder: 155, active: true });
        this._dictionary.add('32', { id: 32, value: 'YEL', displayValue: 'Yellow', description: 'Yellow', sortOrder: 160, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IVehicleColorType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IVehicleColorType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IVehicleColorType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IVehicleColorType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IVehicleColorType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
